import { z } from "zod";

//#region src/lib/zod-filters.ts
let NumberComparisonType = /* @__PURE__ */ function(NumberComparisonType) {
	NumberComparisonType["EQUAL"] = "=";
	NumberComparisonType["GREATER_THAN"] = ">";
	NumberComparisonType["LESS_THAN"] = "<";
	return NumberComparisonType;
}({});
let AndOrType = /* @__PURE__ */ function(AndOrType) {
	AndOrType["AND"] = "and";
	AndOrType["OR"] = "or";
	return AndOrType;
}({});
let ExistenceOperator = /* @__PURE__ */ function(ExistenceOperator) {
	ExistenceOperator["Exists"] = "exists";
	ExistenceOperator["NotExists"] = "notExists";
	return ExistenceOperator;
}({});
const zodBooleanFilter = z.object({ value: z.boolean() });
const zodRangeFilter = z.object({
	min: z.number(),
	max: z.number()
});
const zodNumberFilter = z.object({
	op: z.enum(NumberComparisonType),
	value: z.number()
});
const zodNumericFilter = z.union([zodNumberFilter, zodRangeFilter]);
const zodStringFilter = z.object({ value: z.string() });
const zodRelationFilter = z.object({
	op: z.enum(AndOrType),
	values: z.string().array()
});
/**
* Sentinel value for relation filters meaning "no relation set".
* Selecting it matches items where the related field is absent
* (e.g. inventory lines with no location or no tags).
*/
const UNSET_RELATION_VALUE = "__none__";
const zodExistenceFilter = z.object({ values: z.enum(ExistenceOperator).array() });
function makeZodEnumFilter(inputEnum) {
	return z.object({
		op: z.enum(AndOrType),
		values: z.enum(inputEnum).array()
	});
}

//#endregion
//#region src/lib/helpers.ts
/**
* Returns all values for a filter key, or `[]` if the key is missing or has no values.
* @example
* getFilterValues<CardFinish>(filters, "finishes")
*/
function getFilterValues(filters, key) {
	const filter = filters[key];
	if (filter && "values" in filter) return filter.values;
	return [];
}
function getFirstFilterValue(filters, key, fallback) {
	const values = getFilterValues(filters, key);
	return values.length > 0 ? values[0] : fallback;
}

//#endregion
export { AndOrType, ExistenceOperator, NumberComparisonType, UNSET_RELATION_VALUE, getFilterValues, getFirstFilterValue, makeZodEnumFilter, zodBooleanFilter, zodExistenceFilter, zodNumberFilter, zodNumericFilter, zodRangeFilter, zodRelationFilter, zodStringFilter };
//# sourceMappingURL=index.js.map